import React, { useState } from "react";
// import img1 from "../assets/images/PictureH1.jpg";
// import img2 from "../assets/images/PictureH2.jpg";
// import img3 from "../assets/images/PictureB1.jpg";
// import img4 from "../assets/images/PictureB2.jpg";
import img0 from "../assets/images/PictureH.jpg";

const Skills = () => {

  // const [img, setImg] = useState(false);
  // const [imgD, setImgD] = useState(false);

  // const hover = () => {
  //   setImg(true);
  //   setTimeout(()=>setImgD(true),500);
  // }

  // const nothover = () => {
  //   setImg(false);
  //   setTimeout(()=>setImgD(false),500);
  // }

  return (
    <div className="about-area about-position-top pb--120 bg_color--1">
      <div className="about-wrapper">
        <div className="container">
          <div className="row row--35 align-items-center">
            <div className="col-lg-5 col-md-12">
              <div className="thumbnail show-on-scroll"
                // onMouseOver={hover}
                // onMouseOut={nothover}
              >
                {/* <div>
                  <img
                    style={{position: "absolute"}}
                    className="w-100"
                    src={img3}
                    alt="About Images"
                  />
                  <img
                    className={"w-100 " + (img?"flip-hover":"flip-unhover")}
                    src={imgD?img4:img1}
                    alt="About Images"
                  />
                </div>
                <img
                  style={{position: "relative", zIndex:-1}}
                  className="w-100"
                  src={img2}
                  alt="About Images"
                /> */}
                <img className="w-100" src={img0} alt="About" />
              </div>
            </div>
            <div className="col-lg-7 col-md-12 show-on-scroll">
              <div className="about-inner inner">
                <div className="section-title">
                  <h2 id="About0" className="title">About</h2>
                  <p className="description">
                    Hello, I'm Shivam. I am a Web and Game Developer currently living in Bangalore. 
                    I am experienced in developing user-friendly Mobile and Web Applications.
                    I have also worked on Amazon Web Services and Java applications.
                  </p>
                </div>
                <div className="row mt--30 mt_sm--10">
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="about-us-list">
                      <h3 className="title">Experience</h3>
                      <p>
                        I have 3+ years of experience in designing, developing, 
                        testing and maintaining Web applications.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="about-us-list">
                      <h3 className="title">Purpose</h3>
                      <p>
                        This site is meant to showcase my projects, 
                        and the design process that goes into them.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
